import React, { useEffect, useState } from "react";
import { v4 as uuid } from "uuid";
import { useHistory } from "react-router-dom";
import LogOutButton from "./LogOutButton";
import { Button } from "../components/Button";
import Login from "./Login";
import Onboarding from "./user/Onboarding";
import { useAuth } from "../auth/useAuth";
import Loader from "../components/Loader";
import { styled } from "../stitches.config";

export function generatenewSpaceId() {
  return uuid().replace(/-/g, "");
}
const landing_page_export =
  "https://makespace1.s3.amazonaws.com/pages/landing-page8864d4076f002fe18ce5177a95618431569be6d8be069052e3dadf33d495ed20.html";

function HomeActions() {
  const history = useHistory();

  function createSpace() {
    const newSpaceId = generatenewSpaceId();
    history.push("/space/" + newSpaceId);
  }

  const { auth, hasFetched, refresh } = useAuth();
  const [formOpen, setFormOpen] = useState(false);

  if (auth) {
    return (
      <Onboarding>
        <HomeButtonsContainer>
          <Button color="primary" onClick={createSpace}>
            Create Space
          </Button>
          <LogOutButton />
        </HomeButtonsContainer>
      </Onboarding>
    );
  }
  if (!hasFetched) return <Loader>Loading...</Loader>;
  if (!formOpen) {
    return (
      <HomeButtonsContainer>
        <Button
          size="large"
          color="secondary"
          onClick={() => setFormOpen(true)}
        >
          Log in
        </Button>
      </HomeButtonsContainer>
    );
  }
  return <Login checkAuth={refresh} />;
}

export default function Home() {
  let [dimensions] = useWindowDimensions();
  let mobile_width = 600;
  let computedWidth = Math.min(mobile_width, dimensions.width);

  let scale = computedWidth / mobile_width;
  let margin = (2400 - dimensions.width) / 2;
  return (
    <>
      <FrameContainer>
        <Frame
          width={2400}
          style={{
            transform: `translateX(${-margin}px) scale(${scale})`,
            transformOrigin: "top center",
          }}
          height={dimensions.height / scale}
          scrolling="no"
          title="information about makespace"
          src={landing_page_export}
        ></Frame>
      </FrameContainer>
      <HomeActions />
    </>
  );
}

export const HomeButtonsContainer = styled("div", {
  position: "fixed",
  right: 0,
  top: 0,
  margin: "$2",
});

const FrameContainer = styled("div", {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: "grid",
  zIndex: -1,
  overflow: "hidden",
  backgroundColor: "$beige",
});

const Frame = styled("iframe", {
  margin: "auto",
});

const useWindowDimensions = function () {
  const [dimensions, setDimensions] = React.useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  useEffect(() => {
    function onResize() {
      setDimensions({ height: window.innerHeight, width: window.innerWidth });
    }

    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  });
  return [dimensions];
};
